export const iconFontAwesomeEducationUserGraduate = (
	<i className="fa-solid fa-user-graduate"></i>
);
